export const isChrome = ((): boolean => {
  try {
    return (
      /Chrome/.test(navigator.userAgent) && !/Edg/.test(navigator.userAgent)
    );
  } catch {
    return false;
  }
})();
